// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__u7Ip3","wrapper":"PageHeader_wrapper__zh6-D"};